import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'

import {
  borderRadius,
  breakpoint,
  duration,
  easing,
  size,
} from '@twisto/styles'

export type Sizes = keyof typeof sizes

export const inputWrapper = css`
  padding: 0;
  box-shadow: none;
  position: relative;

  ${breakpoint.up('md')} {
    padding: ${size[0]};
  }
`

export const input = (theme: Theme) => css`
  background-color: ${theme.palette.neutral[100]};
  border-radius: ${borderRadius.sm};
  transition: background-color ${duration.standard}ms ${easing.easeInOut};

  &:not([disabled]):focus {
    box-shadow: 0px 1px 0px 0px ${theme.palette.brand[500]};
  }

  &:not([disabled]):hover,
  &:not([disabled]):focus {
    background-color: ${theme.palette.neutral[200]};
  }
`

export const sizes = {
  small: css`
    padding: ${size[8]};
    padding-left: ${size[56]};
  `,
  medium: css`
    padding: ${size[12]};
    padding-left: ${size[56]};
  `,
  large: css`
    padding: ${size[16]};
    padding-left: ${size[56]};
  `,
}

export const disabledInput = (theme: Theme) => css`
  &::placeholder,
  &.empty {
    color: ${theme.palette.neutral[600]};
  }
`

export const inputIcon = (theme: Theme, barSize: Sizes) => css`
  left: ${size[20]};
  color: ${theme.palette.neutral[700]};
  font-size: ${barSize === 'small' ? size[20] : size[24]};
  margin-right: ${size[12]};
  position: absolute;
  pointer-events: none;
`

export const disabledInputIcon = (theme: Theme) => css`
  color: ${theme.palette.neutral[600]};
`

export const endAdornment = css`
  right: ${size[16]};
  position: absolute;
`
